/**
 * External dependencies
 */
import { combineReducers } from 'redux';
import { reduce, get, omit } from 'lodash';

/**
 * Internal dependencies
 */
import { createReducer } from 'state/utils';
import {
    RENTAL_PLANS_RECEIVE,
    RENTAL_PLANS_REQUEST,
    RENTAL_PLANS_REQUEST_SUCCESS,
    RENTAL_PLANS_REQUEST_FAILURE,
    CURRENT_RENTAL_RECEIVE,
} from 'state/action-types';

export const items = createReducer([], {
    [RENTAL_PLANS_RECEIVE]: (state, action) => {
        return reduce(
            action.payload.items,
            (memo, subscription) => {
                const { id } = subscription;
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = subscription;
                return memo;
            },
            state,
        );
    },
});

export const requesting = createReducer(false, {
    [RENTAL_PLANS_REQUEST]: () => true,
    [RENTAL_PLANS_REQUEST_SUCCESS]: () => false,
    [RENTAL_PLANS_REQUEST_FAILURE]: () => false,
});


export const error = createReducer(false, {
    [RENTAL_PLANS_REQUEST]: () => false,
    [RENTAL_PLANS_REQUEST_SUCCESS]: () => false,
    [RENTAL_PLANS_REQUEST_FAILURE]: () => true,
});


export default combineReducers({
    items,
    requesting,
    error
});
